import axios from 'axios';
import { installOtpCapability } from '../lib/otpChannel';

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL || 'https://localhost:5001/api', withCredentials: true, headers: { 'ngrok-skip-browser-warning': 'true' } });

api.interceptors.request.use(config => {
  const token = localStorage.getItem('partner_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(res => res, err => {
  const token = localStorage.getItem('partner_token');
  // WHATSAPP-OTP-STANDARD-001: Eine 401 der Anmeldung (falsches Passwort, sms_2fa_required,
  // sms_2fa_invalid) sagt nichts über eine bestehende Sitzung — sonst würde der Code-Schritt
  // per Seitenwechsel abgebrochen. Gleiche Regel wie im Admin-Portal.
  const loginRequest = String(err.config?.url || '').replace(/[?#].*$/, '').endsWith('/auth/login');
  // A delayed response only invalidates the session that sent its request.
  if (err.response?.status === 401 && !loginRequest && token && err.config?.headers?.Authorization === `Bearer ${token}`) {
    localStorage.removeItem('partner_token');
    window.location.href = '/login';
  }
  return Promise.reject(err);
});

// WHATSAPP-OTP-STANDARD-001: Token nur an Code-auslösenden POSTs (Liste in lib/otpChannel.js), plus
// einmalige Wiederholung ohne Token, falls ein altes Backend es ablehnt.
installOtpCapability(api);

export default api;
